import React from 'react';

import MainRouter from '@routers/main-router';
import { Wrappers } from '@src/wrappers/index';
import './numeral';
import { ToastContainer } from '@components/atoms/toast/container';

function App() {
  return (
    <Wrappers.AuthWrapper>
      <Wrappers.ApolloWrapper>
        <MainRouter />
        <ToastContainer />
      </Wrappers.ApolloWrapper>
    </Wrappers.AuthWrapper>
  );
}

export default App;
